module.exports = __webpack_public_path__ + "84026c3cd916b18a133637cf58a4e649.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader?limit=1!./src/assets/icons/chrome_app_icon.png
// module id = 1465
// module chunks = 1